/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import { environment } from '../../../apps/veggly/src/environments/environment'; // FOR VEGGLY


const TOKEN_KEY = 'TOKEN';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	// Init with null to filter out the first value in a guard!
	public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public token: string = '';

	constructor(private http: HttpClient) {
		this.loadToken();
	}

	getDetails(): Observable<any> {
		return this.http.get(`${environment.mainServer}/soul`)
			.pipe(
				tap(_ => this.log('response received')),
				catchError(this.handleError('getDetails', []))
			);
	}


	async loadToken() {
		const token = await Preferences.get({ key: TOKEN_KEY });
		if (token && token.value) {
			console.log('set token: ', token.value);
			this.token = token.value;
			this.isAuthenticated.next(true);
		} else {
			this.isAuthenticated.next(false);
		}
	}

	login(data: { email: string, password: string }): Observable<any> {
		const myHeaders = new HttpHeaders(data);
		return this.http.get(`${environment.mainServer}/soul`, { headers: myHeaders, responseType: 'text' }).pipe(
			map((data: any) => data),
			tap((_) => {
				this.isAuthenticated.next(true);
			}),
			catchError(this.handleError('login', []))
		);
	}

	logout(): Promise<void> {
		this.isAuthenticated.next(false);
		return Preferences.remove({ key: TOKEN_KEY });
	}


	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {

			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			this.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(result as T);
		};
	}

	/** Log a AuthenticationService message with the MessageService */
	private log(message: string) {
		console.log(message);
	}

}
